import Router, { useRouter } from 'next/router';

import { useIsWidget } from 'hooks/useIsWidget';
import { StepsProps, useSchedule } from 'hooks/useSchedule';
import { useStorage } from 'hooks/useStorage';

import { currentAppointmentStorageKey } from 'templates/Schedule/shared/hooks/useCreateAppointment';
import {
  scheduleSteps,
  Step,
} from 'templates/Schedule/shared/utils/scheduleSteps';

function getScheduleStepFromIndex(index: number): Step {
  return Object.values(scheduleSteps).find(
    (step) => step.index === index,
  ) as Step;
}

type Params = {
  step: Step;
  steps: StepsProps;
  previousRoute?: Step;
};

export const useScheduleStep = () => {
  const { isWidget } = useIsWidget();
  const router = useRouter();
  const {
    AppointmentInfo: { productSlug },
  } = useSchedule();
  const { remove } = useStorage();

  function goToScheduleStep({ step, steps, previousRoute }: Params) {
    const currentRoutePath = router.pathname;

    if (step.path === scheduleSteps.patientSelection.path)
      remove(currentAppointmentStorageKey);

    if (step.index < 0) {
      if (isWidget) {
        Router.back();

        return;
      }

      if (currentRoutePath === '/schedule/pick-date' && !!productSlug) {
        router.push(`/product/${productSlug}`, `/product/${productSlug}`, {
          scroll: false,
        });

        return;
      }

      if (steps.currentIndex > 1)
        steps.setCurrentIndex(steps.currentIndex + step.index);

      router.back();

      return;
    }

    const stepFromIndex = getScheduleStepFromIndex(steps.currentIndex);

    steps.setPreviousRoute(previousRoute?.path ?? stepFromIndex.path);

    steps.setCurrentIndex(step.index);

    router.push(step.path, step.path, { scroll: false });
  }

  return { goToScheduleStep };
};
